'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwShell = require('./CwShell.scss');

var _CwShell2 = _interopRequireDefault(_CwShell);

var _CwShellLeftNav = require('../cwshellleftnav/CwShellLeftNav');

var _CwShellLeftNav2 = _interopRequireDefault(_CwShellLeftNav);

var _constants = require('../cwshellleftnav/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwShell = function (_React$Component) {
  (0, _inherits3.default)(CwShell, _React$Component);

  function CwShell(props) {
    (0, _classCallCheck3.default)(this, CwShell);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwShell.__proto__ || (0, _getPrototypeOf2.default)(CwShell)).call(this, props));

    _this.setLeftNavActiveButton = function (leftNavActiveButton) {
      _this.setState({ leftNavActiveButton: leftNavActiveButton });
    };

    _this.setLeftNavActiveLink = function (leftNavActiveLink) {
      _this.setState({ leftNavActiveLink: leftNavActiveLink });
    };

    _this.renderChildren = function () {
      return _react2.default.Children.map(_this.props.children, function (child) {
        switch (child.type) {

          case _CwShellLeftNav2.default:
            return _react2.default.cloneElement(child, {
              cwId: _this.props.cwId,
              expand: _this.props.leftNavExpand,
              activeButton: _this.state.leftNavActiveButton,
              activeLink: _this.state.leftNavActiveLink,
              setActiveButton: _this.setLeftNavActiveButton,
              setActiveLink: _this.setLeftNavActiveLink
            });

          default:
            return child;
        }
      });
    };

    _this.state = {
      leftNavActiveButton: null,
      leftNavActiveLink: null
    };

    _this.renderChildren = _this.renderChildren.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CwShell, [{
    key: 'render',
    value: function render() {

      // add left padding based on leftLavExpand value
      var paddingLeft = 0;
      switch (this.props.leftNavExpand) {
        case _constants.CwShellLeftNavExpand.COLLAPSED:
          paddingLeft = _constants.CwShellSizes.COLLAPSED;break;
        case _constants.CwShellLeftNavExpand.DEFAULT:
          paddingLeft = _constants.CwShellSizes.DEFAULT;break;
        case _constants.CwShellLeftNavExpand.FAT:
          paddingLeft = _constants.CwShellSizes.FAT;break;
        case _constants.CwShellLeftNavExpand.SKINNY:
          paddingLeft = _constants.CwShellSizes.SKINNY;break;
        default:
          paddingLeft = 0;
      }

      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId, className: _CwShell2.default.cwShell, style: this.props.style },
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: paddingLeft, paddingTop: 48 } },
          this.renderChildren()
        )
      );
    }
  }]);
  return CwShell;
}(_react2.default.Component);

;

CwShell.propTypes = {
  children: _propTypes2.default.any,
  /**
   *  Connectwise element id to be used as unique identifier
   **/
  cwId: _propTypes2.default.string,
  /**
   *  Determines amount of padding and expansion style of left navigation menu
   **/
  leftNavExpand: _propTypes2.default.oneOf([_constants.CwShellLeftNavExpand.COLLAPSED, _constants.CwShellLeftNavExpand.DEFAULT, _constants.CwShellLeftNavExpand.FAT, _constants.CwShellLeftNavExpand.SKINNY]),
  /**
   * Allows custom styling
   */
  style: _propTypes2.default.object
};

CwShell.defaultProps = {
  cwId: '',
  style: {}
};

exports.default = CwShell;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwshell/CwShell.js
// module id = 852
// module chunks = 10